import apiCall from "../services/ApiServerCall";
import apiServiceCall from "../services/ApiServiceCall";


export const registerLoggedUserInServiceBackend = (requestData) => {
    return apiServiceCall().post('/citizens', requestData).then(({ data }) => data);
}

export const getUser = () => {
    return apiCall().get('/get/auth/user').then(({ data }) => data);
}

export const getValidateSimple = (provider) => {
    return apiCall().get(`/validate/user/simple/external/provider/${provider}`).then(({ data }) => data);
}


export const ValidateComplete = (data) => {
    return apiCall().post('/validate/user/complete/external', data);
}


export const RegisterUserExternal = (data) => {
    return apiCall().post('/register/user/to/external/provider', data);
}
/*
export const getValidateToken = (data) => {
    return apiCall2().post('/validate/token/vui/user', data);
}
*/
export const getValidateToken = () => {
    return apiCall().get('/validate/token/vui/user').then(({ data }) => data);
}

export const getUserExternal = (configData) => {
    return apiCall().get('/get/auth/user', configData).then(({ data }) => data);
}

export const sendCode = (dataToken) => {
    return apiCall().get(`/validate/token/time/${dataToken}`).then(({ data }) => data);
}